module.exports = __webpack_public_path__ + "static/media/YF92_2.291ea86f.jpg";